import React from 'react';
import Tooltip from '@/components/atoms/Tooltip';
import { type ColumnDef } from '@/components/organism/Table';
import { copyToClipboard } from '@/utils/copyToClipboard';
import { getDateTime } from '@/utils/dateTime';
import { ITargetedReconciliationRecord } from '@/services/targetedReconciliation/types';
import { TARGETED_RECONCILIATION_COLUMNS } from './constants';

export function buildColumns(
  isCopy: boolean,
  onCopyClick: () => void,
): ColumnDef<ITargetedReconciliationRecord>[] {
  return [
    {
      accessor: 'providerId',
      header: TARGETED_RECONCILIATION_COLUMNS.PROVIDER_ID,
      render: (item, idx) => (
        <Tooltip id="provider_id_tooltip" showToolTips={isCopy} label="Copy">
          <Tooltip content={item?.providerId} placement="right">
            <span
              className="cursor-pointer hover:text-primary transition-colors overflow-hidden whitespace-nowrap w-[150px] inline-block text-ellipsis"
              onClick={() => {
                copyToClipboard(item?.providerId);
                onCopyClick();
              }}
            >
              {item?.providerId}
            </span>
          </Tooltip>
        </Tooltip>
      ),
    },
    {
      accessor: 'partnerId',
      header: TARGETED_RECONCILIATION_COLUMNS.PARTNER_ID,
      render: (item, idx) => (
        <Tooltip id="partner_id_tooltip" showToolTips={isCopy} label="Copy">
          <Tooltip content={item?.partnerId} placement="right">
            <span
              className="cursor-pointer hover:text-primary transition-colors overflow-hidden whitespace-nowrap w-[150px] inline-block text-ellipsis"
              onClick={() => {
                copyToClipboard(item?.partnerId);
                onCopyClick();
              }}
            >
              {item?.partnerId}
            </span>
          </Tooltip>
        </Tooltip>
      ),
    },
    {
      accessor: 'sourceOperatorId',
      header: TARGETED_RECONCILIATION_COLUMNS.OPERATOR_ID,
      render: (item, idx) => (
        <Tooltip id="operator_id_tooltip" showToolTips={isCopy} label="Copy">
          <Tooltip content={item?.sourceOperatorId} placement="right">
            <span
              className="cursor-pointer hover:text-primary transition-colors overflow-hidden whitespace-nowrap w-[150px] inline-block text-ellipsis"
              onClick={() => {
                copyToClipboard(item?.sourceOperatorId);
                onCopyClick();
              }}
            >
              {item?.sourceOperatorId}
            </span>
          </Tooltip>
        </Tooltip>
      ),
    },
    {
      accessor: 'sourceTransactionId',
      header: TARGETED_RECONCILIATION_COLUMNS.SOURCE_TRANSACTION_ID,
      render: (item, idx) => (
        <Tooltip id="transaction_id_tooltip" showToolTips={isCopy} label="Copy">
          <Tooltip content={item?.sourceTransactionId} placement="right">
            <span
              className="cursor-pointer hover:text-primary transition-colors overflow-hidden whitespace-nowrap w-[150px] inline-block text-ellipsis"
              onClick={() => {
                copyToClipboard(item?.sourceTransactionId);
                onCopyClick();
              }}
            >
              {item?.sourceTransactionId}
            </span>
          </Tooltip>
        </Tooltip>
      ),
    },
    {
      accessor: 'status',
      header: TARGETED_RECONCILIATION_COLUMNS.STATUS,
      sorting: true,
    },
    {
      accessor: 'saleDtm',
      header: TARGETED_RECONCILIATION_COLUMNS.SALE_DTM,
      sorting: true,
      render: (item, idx) => <span>{getDateTime(item?.saleDtm)}</span>,
    },
    {
      accessor: 'updatedOn',
      header: TARGETED_RECONCILIATION_COLUMNS.UPDATED_ON,
      sorting: true,
      render: (item, idx) => <span>{getDateTime(item?.updatedOn)}</span>,
    },
    {
      accessor: 'createdOn',
      header: TARGETED_RECONCILIATION_COLUMNS.CREATED_ON,
      sorting: true,
      render: (item, idx) => <span>{getDateTime(item?.createdOn)}</span>,
    },
  ];
}
